import { createAction, handleActions } from "redux-actions";
import { takeLatest } from "redux-saga/effects";
import { createActionType, createRequestForAnsweringQuestions } from "../../utils/createRequest";
import { recognizeNotes } from "../../api/questionAPI";

const SET = 'answerEditor.SET';
const CLEAR = 'answerEditor.CLEAR';

const [
  RECOGNIZE_NOTES,
  RECOGNIZE_NOTES_SUCCESS,
  RECOGNIZE_NOTES_FAILURE
] = createActionType('answerEditor.RECOGNIZE_NOTES');

const defaultState = {
  isShow: false,
  answers: [],
  answerKey: '',
  cursor: ''
};

const setAnswerEditorAction = createAction(SET, payload => payload);
const recognizeNotesAction = createAction(RECOGNIZE_NOTES, payload => payload);
const clearAnswerEditorAction = createAction(CLEAR);

const recognizeNotesRequest = createRequestForAnsweringQuestions(RECOGNIZE_NOTES, recognizeNotes);

function* answerEditorSaga() {

  yield takeLatest(RECOGNIZE_NOTES, recognizeNotesRequest);

}

const answerEditor = handleActions({
  [SET]: (state, action) => ({ ...state, ...action.payload, cursor: action.payload.cursor || defaultState.cursor }),
  [RECOGNIZE_NOTES_SUCCESS]: (state, action) => {
    return ({
      ...state,
      answers: action.payload,
      answerKey: `${action.payload || ''}?overwrite`,
      cursor: defaultState.cursor
    });
  },
  [RECOGNIZE_NOTES_FAILURE]: console.log,
  [CLEAR]: () => defaultState
}, defaultState);

export default answerEditor;
export {
  setAnswerEditorAction,
  recognizeNotesAction,
  clearAnswerEditorAction,
  answerEditorSaga
};
